import {
  getSuperVisioryAction,
  getSuperVisioryTextAction,
} from "../redux/Reducers/superVisioryReducer";
import { BASE_URL } from "./BASE_URL";

export const getSuperVisiory = () => {
  return async (dispatch) => {
    const response = await fetch(
      BASE_URL + "team/supervisory_board/?limit=550"
    );
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getSuperVisioryAction(data.results));
    }
  };
};

export const getSuperVisioryText = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + "index/supervisory_text/");
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getSuperVisioryTextAction(data.text));
    }
  };
};
